import React from 'react';
import './NosChiffresCles.css';
import { FaUniversity, FaBuilding, FaBriefcase, FaUsers, FaGlobeAfrica, FaChartLine, FaMoneyBillWave } from 'react-icons/fa';

const NosChiffresCles = () => {
  const stats = [
    {
      id: 1,
      icon: <FaUniversity />,
      number: "+60",
      title: "écoles françaises partenaires",
      color: "#1e3c72"
    },
    {
      id: 2,
      icon: <FaBuilding />,
      number: "160",
      title: "résidences étudiantes",
      color: "#2a5298"
    },
    {
      id: 3,
      icon: <FaBriefcase />,
      number: "+30",
      title: "entreprises partenaires",
      color: "#dc143c"
    },
    {
      id: 4,
      icon: <FaUsers />,
      number: "+5000",
      title: "étudiants étrangers accompagnés",
      color: "#ff3855"
    }
  ];

  const constats = [
    {
      id: 1,
      icon: <FaUsers />,
      number: "450 000",
      description: "étudiants étrangers",
      detail: "arrivent en France chaque année",
      color: "#1e3c72"
    },
    {
      id: 2,
      icon: <FaChartLine />,
      number: "75% (Licence) et 62% (Master)",
      description: "étudiants étrangers",
      detail: "taux d'échec",
      color: "#dc143c"
    },
    {
      id: 3,
      icon: <FaGlobeAfrica />,
      number: "Afrique, Asie, Océanie, Amérique",
      description: "étudiants étrangers",
      detail: "issue de ces continents",
      color: "#2a5298"
    },
    {
      id: 4,
      icon: <FaMoneyBillWave />,
      number: "5 milliard d'euros / an",
      description: "contribution économique",
      detail: "à l'économie de la France",
      color: "#ff3855"
    }
  ];

  return (
    <section className="nos-chiffres-section" id="chiffres-cles">
      <div className="chiffres-background">
        <div className="chiffres-glow chiffres-glow-1"></div>
        <div className="chiffres-glow chiffres-glow-2"></div>
        <div className="chiffres-grid"></div>
      </div>

      <div className="chiffres-container">
        {/* Header */}
        <div className="chiffres-header">
          <h2 className="chiffres-title">
            NOS CHIFFRES CLÉS
            <span className="chiffres-underline"></span>
          </h2>
          <p className="chiffres-subtitle">
            Notre réseau en chiffre
          </p>
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          {stats.map((stat) => (
            <div className="stat-card" key={stat.id}>
              <div className="stat-icon-wrapper" style={{ backgroundColor: `${stat.color}15` }}>
                <div className="stat-icon" style={{ color: stat.color }}>
                  {stat.icon}
                </div>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{stat.number}</h3>
                <p className="stat-title">{stat.title}</p>
              </div>
              <div className="stat-decoration" style={{ background: `linear-gradient(135deg, ${stat.color}, transparent)` }}></div>
            </div>
          ))}
        </div>

        {/* Constats Section */}
           {/* Constats Section */}
      <div className="constats-section">
        <div className="constats-header">
          <h3 className="constats-title">Constat</h3>
          <p className="constats-intro">L'importance des étudiants étrangers en France</p>
        </div>

        <div className="constats-grid-4">
          {constats.map((constat) => (
            <div className="constat-card" key={constat.id}>
              <div className="constat-icon-wrapper">
                <div className="constat-icon" style={{ color: constat.color }}>
                  {constat.icon}
                </div>
              </div>
              <div className="constat-content">
                <h4 className="constat-number">{constat.number}</h4>
                <p className="constat-description">{constat.description}</p>
                <p className="constat-detail">{constat.detail}</p>
              </div>
              <div className="constat-bg" style={{ backgroundColor: `${constat.color}10` }}></div>
            </div>
          ))}
        </div>
      </div>

    

      </div>
    </section>
  );
};

export default NosChiffresCles;